/** Keep accidental outside clicks from closing a working window. */
export const preventBackdropDismiss = (event) => {
  const surface = event.currentTarget;
  const target = event.target;
  // React events from a nested portal also reach its React parents. Only the
  // surface that actually contains the clicked element may handle this click.
  if (!surface?.contains(target)) return;
  const modal = surface.closest('.MuiModal-root');
  // Navigation drawers should close when the user clicks outside them.
  if (modal?.getAttribute('data-allow-backdrop-dismiss') === 'true') return;
  // Menus/select lists dismiss themselves; they must not dismiss their editor.
  if (modal?.classList.contains('MuiMenu-root')) return;
  const outside = target === surface || target.classList?.contains('MuiBackdrop-root')
    || target.classList?.contains('MuiDialog-container');
  if (!outside) return;
  event.preventDefault();
  event.stopPropagation();
};
